var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content vip_to_unlimit_popup" }, [
          _c("div", { staticClass: "popup_title" }, [
            _c("div", { staticClass: "popup_title_bg" }),
            _vm._v(" "),
            _c("div", { staticClass: "popup_title_content" }, [
              _c("div", { staticClass: "popup_title_main" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "popup_title_sub" }, [
                _vm._v(_vm._s(_vm.desc))
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "popup_title_close",
                on: {
                  click: function($event) {
                    _vm.isShow = !_vm.isShow
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "popup_content" },
            _vm._l(_vm.allowSchemes, function(allowScheme, index) {
              return _c("paySchemeTab", {
                key: index,
                ref: "payScheme",
                refInFor: true,
                attrs: {
                  payScheme: allowScheme,
                  index: index,
                  isVIP: "true",
                  "data-popup": "",
                  "data-last": index == _vm.allowSchemes.length - 1 ? "Y" : "N"
                }
              })
            }),
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f2778a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f2778a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/upgrade_popups/upgrade_account_vip_popup.vue
// module id = null
// module chunks = 